export const defaultReviewsField = [
  "image",
  "product_name",
  "description",
  "review_title",
  "average_review",
  "review_count",
  "action",
];

export const REVIEW_SORT_KEYS = ["product_name", "average_review", "review_count", "review_title", "createdAt"]